import * as Sentry from '@sentry/angular';
import { environment } from '../../../environments/environment';

export const isSentryEnabled =
  !!environment.sentry.dsn && !environment.sentry.dsn.startsWith('__');

export function initSentry(): void {
  if (!isSentryEnabled) {
    return;
  }

  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: environment.sentry.release,
    tracesSampleRate: environment.sentry.tracesSampleRate,
    replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate,
    replaysOnErrorSampleRate: environment.sentry.replaysOnErrorSampleRate,
    tracePropagationTargets: environment.sentry.tracePropagationTargets,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  });
}
